import { IFactoringProfile, IPaymentSpeed } from "models/HaulPay";
import { IInviteInformation } from "models/User";
import { RootState } from "store";

const EMPTY_USER_DETAILS: any = {};

export const selectUserDetails = (state: RootState) =>
  state.userState.userDetails ?? EMPTY_USER_DETAILS;
export const selectOnboardingInformation = (state: RootState): IInviteInformation =>
  state.userState.ICOnboardingInformation;
export const selectPaymentTerms = (state: RootState): IPaymentSpeed[] =>
  state.userState.paymentTerms;
export const selectFactoringProfile = (state: RootState): IFactoringProfile =>
  state.userState.factoringProfile;
